import computeCategory from './computeCategory.u';
import icon1 from '../img/category/1.svg';
import icon2 from '../img/category/2.svg';
import icon4 from '../img/category/4.svg';
import icon5 from '../img/category/5.svg';
import icon6 from '../img/category/6.svg';
import icon7 from '../img/category/7.svg';
import icon8 from '../img/category/8.svg';
import icon9 from '../img/category/9.svg';
import icon10 from '../img/category/10.svg';
import icon11 from '../img/category/11.svg';
import icon12 from '../img/category/12.svg';
import icon13 from '../img/category/13.svg';
import icon14 from '../img/category/14.svg';
import icon15 from '../img/category/15.svg';
import icon17 from '../img/category/17.svg';
import iconCred from '../img/category/100000000000895.svg';
import iconDep from '../img/category/100000000000896.svg';
import {
    CATEGORY_APPLIANCES,
    CATEGORY_BUILDING,
    CATEGORY_CAFE,
    CATEGORY_CAR,
    CATEGORY_CASH,
    CATEGORY_CLOTHES,
    CATEGORY_COMMUNAL,
    CATEGORY_CREDIT_PERCENTS,
    CATEGORY_DEPOSIT,
    CATEGORY_ENTERTAINMENT,
    CATEGORY_FOOD,
    CATEGORY_FUEL,
    CATEGORY_HEALTH,
    CATEGORY_MOBILE,
    CATEGORY_OTHER,
    CATEGORY_TOURISM,
    CATEGORY_TRANSFERS,
} from '../variables';

const customIcons = {
    [CATEGORY_APPLIANCES]: icon1,
    [CATEGORY_CASH]: icon2,
    [CATEGORY_HEALTH]: icon4,
    [CATEGORY_CAFE]: icon5,
    [CATEGORY_COMMUNAL]: icon6,
    [CATEGORY_CLOTHES]: icon7,
    [CATEGORY_TRANSFERS]: icon8,
    [CATEGORY_MOBILE]: icon9,
    [CATEGORY_FOOD]: icon10,
    [CATEGORY_OTHER]: icon11,
    [CATEGORY_ENTERTAINMENT]: icon12,
    [CATEGORY_CAR]: icon13,
    [CATEGORY_BUILDING]: icon14,
    [CATEGORY_TOURISM]: icon15,
    [CATEGORY_FUEL]: icon17,
    [CATEGORY_CREDIT_PERCENTS]: iconCred,
    [CATEGORY_DEPOSIT]: iconDep,
};

export default function(model, settings) {
    let result = null;

    if (model && settings) {
        const category = computeCategory(model, settings),
            icons = settings.get('icons');

        if (customIcons[category]) {
            result = customIcons[category];
        } else if (icons[category]) {
            result = `data:image/jpg;base64,${icons[category].isc}`;
        } else {
            // other
            result = icon8;
        }
    }

    return result;
}
